import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const PROGRESS_BAR_HEIGHT = "8px";
const PROGRESS_TRANSITION = "width 0.5s ease";

export const useRefreshStatusBannerStyles = makeStyles({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[4],
    paddingLeft: designTokens.spacing[6],
    paddingRight: designTokens.spacing[6],
    backgroundColor: designTokens.neutral.white,
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  icon: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: designTokens.accent[500],
  },
  title: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[900],
  },
  progressSection: {
    minWidth: 0,
  },
  progressBar: {
    height: PROGRESS_BAR_HEIGHT,
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.neutral[200],
    overflow: "hidden",
    marginBottom: designTokens.spacing[2],
  },
  progressFill: {
    height: "100%",
    backgroundColor: designTokens.accent[500],
    borderRadius: designTokens.borderRadius.full,
    transition: PROGRESS_TRANSITION,
  },
  progressMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: designTokens.spacing[3],
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[700],
  },
  progressMetaValue: {
    flexShrink: 0,
  },
});
